export default __webpack_public_path__ + "static/media/logo.116305a3.png";